let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("huTg5")).then(() => parcelRequire('2ywPV'));